import React from 'react';
import {connect} from 'react-redux';
import MaterialTable from 'material-table';
import moment from 'moment'
import UserModal from './UserModal';
import {Redirect} from 'react-router-dom';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {getUsers} from '../dashboard/dashboard.actions';
import {deleteUser, updateUser, selectedUser, addUser} from './users.actions';
import {isEmpty} from 'lodash'
 
const Users = (props)  => {
  const usersData= props.users;  
  const [open, setOpen] = React.useState(false);
  const [state, setState] = React.useState({
    columns: [
      { title: 'First Name', field: 'first_name' },
      { title: 'Last Name', field: 'last_name' },
      { title: 'City', field: 'city' },
      { title: 'Phone #', field: 'phone' },
      { title: 'Last Login', field: 'last_login', render: rowData => isEmpty(rowData.last_login) ? "Never Login" : rowData.last_login},
      { title: 'Email Address', field: 'email', editable: 'onAdd' },
      { title: 'Package Name', field: 'user_package_id', lookup: { 1: 'Trial', 2: 'Premium', 3: 'Free', 4: 'Closed' } },
      { title: 'Joining Date', field: 'createdAt', render: rowData => moment(rowData.date_created).format('MM-DD-YYYY'), type: 'date',  editable: 'onAdd' },
      { title: 'Password', field: 'password',  render: rowData =>   'XXX'  }
    ]
  });
  const [callEdit, setcallEdit] = React.useState(false);
  if (callEdit) {
    return <Redirect push to="/View User" />;
  }
  return (
    
    <>    
    { open && <UserModal open = {open}/>}
    <MaterialTable
      title="Users"
      columns={state.columns}
      data={usersData}
      actions={[
        {
        icon: VisibilityIcon,
          tooltip: 'View User',
          onClick: (event, rowData) => {
            // Do save operation
            setcallEdit(true);
            
            props.viewSelectedUser(rowData)
          }
        }
      ]}
      options={{
        actionsColumnIndex: -1,
        headerStyle: { position: 'sticky', top: 0,
        color: '#00BBBB',
        fontWeight: '550',
        onRowAdd: 'none',
        }
      }}
      editable={{
        onRowAdd: (newData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              props.addUserFunction(newData)
            }, 600);
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              if (oldData) {
                props.updateUserFunction(newData, oldData)

              }
            }, 600);
          }),
        onRowDelete: (oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve();
              props.deleteUserFunction(oldData.user_id);
            }, 600);
          }),
      }}
    />
    </>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    getUsers: () => dispatch(getUsers()),
    deleteUserFunction: (id) => dispatch(deleteUser(id)),
    updateUserFunction: (data, oldData) => dispatch(updateUser(data, oldData)),
    viewSelectedUser: (data) => dispatch(selectedUser(data)),
    addUserFunction: (data) => dispatch(addUser(data)),
  }
}

const mapStateToProps =(state, ownProps, number)  =>({
      users : state.dashboardReducer.users,
      userDeleted: state.usersReducer.userDeleted
    })

export default connect(mapStateToProps,mapDispatchToProps)(Users);